import { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  List,
  ListItemButton,
  ListItemText
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

export default function Configurations() {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const mode = params.get("mode");

  const heading = mode === "maintenance" ? "Maintenance" : "Configurations";

  const [modules, setModules] = useState([]);
  const [selectedModule, setSelectedModule] = useState(null);

  const [features, setFeatures] = useState([]);
  const [selectedFeature, setSelectedFeature] = useState(null);

  const [items, setItems] = useState([]);

  /* ================= LEVEL 1 ================= */

  useEffect(() => {
    fetch("https://apiservices.iepa.in:8191/iepa/api/configuration")
      .then((res) => res.json())
      .then(setModules)
      .catch(console.error);
  }, []);

  /* ================= LEVEL 2 ================= */

  const loadFeatures = async (level1Value) => {
    setSelectedModule(level1Value);
    setSelectedFeature(null);
    setFeatures([]);
    setItems([]);

    try {
      const res = await fetch(
        `https://apiservices.iepa.in:8191/iepa/api/configuration/level1/${encodeURIComponent(
          level1Value
        )}`
      );

      const data = await res.json();

      // Extract unique level2 values
      const uniqueFeatures = [...new Set(data.map((d) => d.level2))];

      setFeatures(uniqueFeatures);
    } catch (err) {
      console.error(err);
    }
  };

  /* ================= LEVEL 3 ================= */

  const loadItems = async (level2Value) => {
    setSelectedFeature(level2Value);
    setItems([]);

    try {
      const res = await fetch(
        `https://apiservices.iepa.in:8191/iepa/api/configuration/level1/${encodeURIComponent(
          selectedModule
        )}/level2/${encodeURIComponent(level2Value)}`
      );

      const data = await res.json();

      setItems(data);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Box p={2}>
      <Typography variant="h4" mb={2}>
        {heading}
      </Typography>

      <Grid container spacing={2}>
        {/* ================= LEVEL 1 ================= */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Modules
            </Typography>

            <List>
              {modules.map((m) => (
                <ListItemButton
                  key={m.id}
                  selected={selectedModule === m.level1}
                  onClick={() => loadFeatures(m.level1)}
                >
                  <ListItemText primary={m.level1} />
                </ListItemButton>
              ))}
            </List>
          </Paper>
        </Grid>

        {/* ================= LEVEL 2 ================= */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Features
            </Typography>

            {selectedModule ? (
              <List>
                {features.map((f) => (
                  <ListItemButton
                    key={f}
                    selected={selectedFeature === f}
                    onClick={() => loadItems(f)}
                  >
                    <ListItemText primary={f} />
                  </ListItemButton>
                ))}
              </List>
            ) : (
              <Typography p={2}>Select a module</Typography>
            )}
          </Paper>
        </Grid>

        {/* ================= LEVEL 3 ================= */}
        <Grid item xs={4}>
          <Paper sx={{ height: "80vh", overflow: "auto" }}>
            <Typography variant="h6" p={2}>
              Items
            </Typography>

            {selectedFeature ? (
              <List>
                {items.map((item) => (
                  <ListItemButton
                    key={item.id}
                    onDoubleClick={() => navigate(item.url)}
                  >
                    <ListItemText
                      primary={item.level3}
                      sx={{ color: "#1976d2", cursor: "pointer" }}
                    />
                  </ListItemButton>
                ))}
              </List>
            ) : (
              <Typography p={2}>Select a feature</Typography>
            )}
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
}